import React, { useMemo } from "react"
import { useDispatch } from "react-redux"
import AgendaRdvModal from "../../agenda/AgendaRdvModal"
import { postRdv } from "../../../store/actions/agendaActions"

const nomClient = (e) =>
	e.label || `${e.prenom || ""} ${e.nom || ""}`.trim()

// Création d'un Rdv pré-rempli depuis un client. Réutilise AgendaRdvModal
// (le même formulaire qu'à l'agenda) ; seul le client est préremplit. La
// persistance (POST api/rdvs) passe par le thunk postRdv, comme à l'agenda.
const ClientToRdvModalV2 = ({ entite, onClose }) => {
	const dispatch = useDispatch()
	const prefill = useMemo(
		() => ({
			client: nomClient(entite),
			clientId: entite.id || null,
			telephone: entite.telephone || "",
		}),
		[entite],
	)

	const onSave = (payload) =>
		dispatch(postRdv(payload)).then((res) => {
			if (res) onClose()
		})

	return (
		<AgendaRdvModal
			prefill={prefill}
			editing={null}
			onClose={onClose}
			onSave={onSave}
		/>
	)
}

export default ClientToRdvModalV2
